import styled from 'styled-components';

// import { headerVariables } from '../Header/HeaderStyle';

import { colors, fontFamily, breakpoints } from '../../ui/variables';

export const AddInstitutionFormStyle = styled.div`
  .header-institution-registration {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 73px;
    margin-bottom: 35px;
    padding-right: 0;
    padding-left: 0;

    @media (min-width: 1300px) {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding-right: 10%;
      padding-left: 5%;
    }

    .title-header {
      ${fontFamily.sourceSansPro.bold}
      font-size: 24px;
      margin-bottom: 10px;
      text-align: center;

      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        text-align: auto;
      }
      .number-of-registers {
        /* display: none; */
        /* @media (min-width: ${breakpoints.ipadLandscape.width}px) { */
        display: inline-block;
        ${fontFamily.sourceSansPro.regular}
        font-size: 14px;
        /* } */

        .score {
          ${fontFamily.sourceSansPro.bold}
          font-size: 14px;
          margin-left: 20px;
        }
      }
    }
  }

  .register-institution-form {
    margin-top: 5px;
    width: 100%;
    height: 100%;
    min-width: 100%;
    padding-left: 0;
    padding-right: 0;

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      padding-right: 10%;
      padding-left: 5%;
    }

    .error-message {
      margin-top: 3px;
      ${fontFamily.sourceSansPro.bold};
      font-size: 14px;
      color: ${colors.softRed};
    }

    .title-unit {
      font-size: 14px;
      display: flex;
      align-items: center;
      padding-left: 30px;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      vertical-align: center;
      height: 49px;
      background-color: ${colors.mostlyWhite};
      position: relative;
      .view-button {
        color: ${colors.grayishBlue};
        position: absolute;
        right: 30px;
      }
    }

    .institution-data {
      background-color: ${colors.veryPaleBlue};
      padding-top: 17px;
      padding-left: 30px;
    }

    .input-label-form {
      font-size: 14px;
    }
    .register-institution-wrapper {
      background-color: ${colors.veryPaleBlue};
      display: flex;
      flex-direction: column-reverse;
      align-items: center;
      justify-content: space-around;
      padding-top: 23px;
      position: relative;
      height: 100%;

      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        height: 750px;
      }

      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        padding-top: 0px;
      }

      .logo-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          width: 70%;
          justify-content: flex-start;
        }

        .image-label {
          width: 30%;
          margin-bottom: 15px;
          font-size: 14px;
        }

        .logo {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 218px;
          width: 218px;
          border-radius: 50%;
          background-color: ${colors.mostlyWhite};
          position: relative;
          background-size: cover;
          background-position: center;

          .input-file {
            position: absolute;
            opacity: 0;
            height: 218px;
            width: 218px;
            cursor: pointer;
          }

          .add {
            background-color: ${colors.softBlue};
            border-radius: 50%;
            position: absolute;
            right: -22px;
            height: 44px;
            width: 44px;
            display: flex;
            align-items: center;
            justify-content: center;

            svg {
              fill: white;
              height: 22px;
              width: 22px;
            }
          }
          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            height: 218px;
            width: 218px;
            border-radius: 50%;
          }
        }

        .add-logo {
          ${fontFamily.sourceSansPro.normal};
          color: ${colors.veryDarkGrayishBlue};
          margin-top: 18px;
        }
      }

      .register-unit-form {
        width: 100%;
        height: 100%;
        padding-left: 30px;
        padding-top: 20px;
        padding-right: 30px;
        padding-bottom: 30px;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          width: 50%;
          padding-left: 30px;
          padding-right: 0px;
          height: 569px;
        }

        .input-label-form {
          margin-bottom: 20px;
          width: 100%;
          height: 70px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          &.select-add-responsible {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width: 100%;

            @media (min-width: ${breakpoints.uxga.width}px) {
              flex-direction: row;
              align-items: center;
            }

            .label {
              width: 100%;
              @media (min-width: ${breakpoints.uxga.width}px) {
                width: 27%;
              }
            }

            .input {
              margin-top: 5px;
              width: 100%;
            }
          }

          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            flex-direction: row;
          }

          .label {
            width: 100%;
            @media (min-width: ${breakpoints.ipadLandscape.width}px) {
              width: 20%;
            }
          }

          .input {
            width: 100%;
            @media (min-width: ${breakpoints.ipadLandscape.width}px) {
              width: 78%;
            }
          }

          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-around;
          }
        }

        .number-complement {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          .input-label-form {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            width: 50%;
            height: 70px;

            @media (min-width: ${breakpoints.uxga.width}px) {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              width: 50%;
            }

            &.number {
              width: 45%;
            }

            .label {
              width: 100%;
              margin-right: 0;
              @media (min-width: ${breakpoints.uxga.width}px) {
                width: 10%;
                margin-right: 5%;
              }
            }

            .input {
              width: 100%;

              @media (min-width: ${breakpoints.uxga.width}px) {
                width: 60%;
              }

              &.number {
                width: 100%;

                @media (min-width: ${breakpoints.uxga.width}px) {
                  width: 50%;
                }
              }
            }
          }
        }

        .add-responsible {
          width: 100%;
          color: ${colors.softBlue};
          ${fontFamily.sourceSansPro.bold};
          font-size: 14px;
        }
      }
    }

    .admin-form {
      padding-top: 15px;
      padding-left: 20px;
      padding-right: 20px;
      width: 100%;
      background-color: ${colors.mostlyWhite};

      .form-container {
        display: flex;
        flex-direction: column;
        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
        }
      }

      .personal-admin-data,
      .address-admin-data {
        border: 0 none;
        width: 100%;
        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          width: 42%;
          margin-right: 0;
        }

        .input-label-form {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 75px;
          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            flex-direction: row;
            height: auto;
          }
          .label {
            width: 100%;
            @media (min-width: ${breakpoints.ipadLandscape.width}px) {
              width: 15%;
            }
          }

          .input {
            width: 100%;
            @media (min-width: ${breakpoints.ipadLandscape.width}px) {
              width: 80%;
            }
          }
        }
      }

      .input-label-form {
        margin-top: 20px;
        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          display: flex;
          align-items: center;
        }
        .label {
          width: 30%;
          margin-right: 5%;
        }
        .input {
          margin-bottom: 5px;
          width: 60%;
          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            margin-bottom: 0px;
          }
        }
      }

      .telephone {
        /* display: flex;
        flex-direction: row; */
        width: 100%;

        .input-label-form {
          width: 100%;
          height: 70px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            flex-direction: row;
          }
          .label {
            width: 100%;
            @media (min-width: ${breakpoints.ipadLandscape.width}px) {
              width: 15%;
            }
          }
          .inputs {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            width: 100%;

            @media (min-width: ${breakpoints.ipadLandscape.width}px) {
              width: 85%;
              display: flex;
              flex-direction: row;
            }

            .phone-code {
              width: 30%;
            }

            .phone-number {
              width: 65%;
            }
          }
        }
      }

      .number-complement {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        .input-label-form {
          display: flex;
          flex-direction: column;
          /* align-items: center; */
          justify-content: space-between;
          width: 50%;
          height: 70px;

          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            width: 50%;
          }

          &.number {
            width: 45%;
          }

          .label {
            width: 100%;
            margin-right: 0;
            @media (min-width: ${breakpoints.ipadLandscape.width}px) {
              width: 30%;
              margin-right: 5%;
            }
          }

          .input {
            width: 100%;

            @media (min-width: ${breakpoints.ipadLandscape.width}px) {
              width: 60%;
            }

            &.number {
              width: 100%;

              @media (min-width: ${breakpoints.ipadLandscape.width}px) {
                width: 50%;
              }
            }
          }
        }
      }
    }

    .form-container {
      height: 100%;
      display: block;

      transition: height 1s;

      /* &.hide {
        display: none;
      } */
    }
  }

  .add-new-institution {
    margin-top: 40px;
    display: flex;
    justify-content: center;
    width: 100%;
    color: ${colors.softBlue};

    .text {
      margin-left: 17px;
    }

    .plus-container {
      display: flex;
      justify-content: center;
      height: 20px;
      width: 20px;
      border-radius: 50%;
      border: 2px solid ${colors.softBlue};
      svg {
        fill: ${colors.softBlue};
        height: 10px;
        width: 10px;
        align-self: center;
        justify-self: center;
      }

      .negative-container{
        display: flex;
        justify-content: center;
        height: 20px;
        width: 20px;
        border-radius: 50%;
        border: 2px solid ${colors.softRed};
        svg {
          fill: ${colors.softRed};
        }
      }
    }
  }

  .action-buttons {
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;
    margin-top: 30px;
    @media (min-width: 500px) {
      width: 45%;
      min-width: 450px;
      flex-direction: row;
      align-items: center;
    }
    .button-wrapper {
      display: flex;
      width: 100%;
      padding: 0 20px;
      height: 45px;
      margin-top: 10px;

      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        margin-top: 0px;
        width: 219px;
        padding: 0;
      }
    }
  }
`;
